import { SpaceExtraSeatsFeature, SpacesFeature } from '@/shared/types/Settings';
import { UpgradeAlert } from '@/shared/ui/UpgradeAlert';

import { getUpgradeAlertText } from '../lib/getUpgradeAlertText';

export type TeamspaceUpgradeAlertProps = {
  extraSeatsFeature?: SpaceExtraSeatsFeature;
  spacesFeature: SpacesFeature;
  onClick: () => void;
};

export const TeamspaceUpgradeAlert = ({ extraSeatsFeature, spacesFeature, onClick }: TeamspaceUpgradeAlertProps) => {
  const isEnabled = spacesFeature.enabled;
  const extraSeats = extraSeatsFeature?.metadata?.quantity || 0;

  let buttonText = 'Upgrade';

  if (!isEnabled) {
    buttonText = 'Get Started';
  } else if (extraSeats === 0) {
    buttonText = 'Add more';
  }

  return <UpgradeAlert buttonText={buttonText} text={getUpgradeAlertText(spacesFeature, extraSeats)} onClick={onClick} />;
};
